import { CanActivateChildFn } from '@angular/router';
import { inject } from '@angular/core';
import { Role } from '../enum';
import { UserInfoService } from '../services';

export const roleGuard: CanActivateChildFn = childRoute => {
  const data = childRoute.routeConfig?.data as { role: Role[] };
  const jwt = inject(UserInfoService).jwt();
  if (jwt && data) {
    const authorities = jwt.authorities.split(',').map(role => role.replace('ROLE_', '')) as Role[];
    return authorities.some(role => data.role.includes(role));
  }
  return false;
};
